import { render, staticRenderFns } from "./IssueStatusLog.vue?vue&type=template&id=30a997aa&"
import script from "./IssueStatusLog.vue?vue&type=script&lang=ts&"
export * from "./IssueStatusLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports